<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :dark="barColor !== 'rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.7)'"
    :right="$vuetify.rtl"
    :src="barImage"
    app
    width="300"
    v-bind="$attrs"
  >
    <template v-slot:img="props">
      <v-img
        :gradient="`to bottom, ${barColor}`"
        v-bind="props"
      />
    </template>

    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title class="text-uppercase font-weight-regular display-2">
          <span class="ml-2 mr-6">Eurocom Club</span>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list
      expand
      nav
    >
      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />

      <template v-for="(item, i) in computedItems">
        <base-item-group
          v-if="item.children && item.if($store.state.user.role)"
          :key="`group-${i}`"
          :item="item"
        >
          <!--  -->
        </base-item-group>

        <base-item
          v-if="!item.children && item.if($store.state.user.role)"
          :key="`item-${i}`"
          :item="item"
        />
      </template>

      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  // Utilities
  import {
    mapState,
  } from 'vuex'

  export default {
    name: 'DashboardCoreDrawer',

    props: {
      expandOnHover: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      items: [
        {
          icon: 'mdi-view-dashboard',
          title: 'Главная',
          to: '/',
          if: (role) => true,
        },
        {
          icon: 'mdi-account-settings',
          title: 'Профиль',
          to: '/profile',
          if: (role) => true,
        },
        {
          icon: 'mdi-home-city',
          title: 'Оформление ДТП',
          to: '/accident/create/short',
          if: (role) => role == 5 || role == 9,
        },
        {
          icon: 'mdi-home-city',
          title: 'Оформление ДТП',
          to: '/accident/create',
          if: (role) => role != 3 && role != 5 && role!= 9,
        },
        {
          icon: 'mdi-account-box-multiple',
          title: 'Список ДТП',
          to: '/accident/list',
          if: (role) => role != 3 && role != 5,
        },
        {
          icon: 'mdi-account-card-details',
          title: 'История ДТП',
          to: '/accident/list/short',
          if: (role) => role == 5,
        },
        {
          icon: 'mdi-file-document',
          title: 'Список договоров',
          to: '/contract/list',
          if: (role) => role != 3 && role != 4 && role != 5,
        },
        {
          icon: 'mdi-table-settings',
          title: 'События',
          to: '/event/list',
          if: (role) => role != 4 && role != 5 && role != 3 && role!=9,
        },

        {
          icon: 'mdi-account-settings',
          title: 'Пользователи',
          to: '/users/list',
          if: (role) => role == 1,
        },
        {
          icon: 'mdi-table-settings',
          title: 'Справочники',
          to: '/dictionary/list',
          if: (role) => role == 1,
        },
        {
          icon: 'mdi-table-settings',
          title: 'Логи',
          to: '/log/list',
          if: (role) => role == 1,
        },
        {
          icon: 'mdi-camera',
          title: 'Ссылки на фото',
          to: '/photo/list',
          if: (role) => role == 1,
        },
        {
          icon: 'mdi-table-settings',
          title: 'Настройки системы',
          to: '/setting/list',
          if: (role) => role == 1,
        },
        {
          icon: 'mdi-car',
          title: 'Транспортные средства',
          to: '/vehicle/list',
          if: (role) => role != 3 && role != 4 && role != 5 && role!=9,
        },
        {
          icon: 'mdi-account-group',
          title: 'Клиенты',
          to: '/driver/list',
          if: (role) => role != 3 && role != 4 && role !=5  && role!=9,
        },

        {
          icon: 'mdi-account-cash',
          title: 'Страхование',
          group: '/insurance',
          if: (role) => role != 2 && role != 4 && role != 5 && role!=9,
          children: [
            {
              icon: 'mdi-file-document-box-multiple',
              title: 'Страховые полисы',
              to: 'list',
              if: (role) => role == 1 || role == 2 || role == 6,
            },
            {
              icon: 'mdi-file-document-box-multiple',
              title: 'Страховые полисы',
              to: 'list/manager',
              if: (role) => role == 3,
            },
            {
              icon: 'mdi-file-document-box-multiple',
              title: 'Задания',
              to: 'event/list',
              if: (role) => role == 1 || role == 2 || role == 3 || role == 6,
            },
            {
              icon: 'mdi-file-document-box-multiple',
              title: 'Отчеты',
              to: 'report',
              if: (role) => role == 1 || role == 6,
            },
          ],
        },
        {
          icon: 'mdi-bank',
          title: 'Операции',
          group: '/transaction',
          if: (role) => role == 1 || role == 2,
          children: [
            {
              icon: 'mdi-file-document-box-multiple',
              title: 'Операции по договору',
              to: 'list',
              if: (role) => role == 1 || role == 2,
            },
            {
              icon: 'mdi-file-document-box-multiple',
              title: 'Операции по счету',
              to: 'operations',
              if: (role) => role == 1 || role == 2,
            },
          ],
        },
        {
          icon: 'mdi-finance',
          title: 'Отчеты',
          group: '/reports',
          if: (role) => role == 1 || role == 2,
          children: [
            {
              icon: 'mdi-file-document-box-multiple',
              title: 'По договорам',
              to: 'contracts',
              if: (role) => role == 1 || role == 2,
            },
            {
              icon: 'mdi-file-document-box-multiple',
              title: 'По комиссарам',
              to: 'comissars',
              if: (role) => role == 1 || role == 2,
            },
            {
              icon: 'mdi-file-document-box-multiple',
              title: 'По страховым',
              to: 'insurers',
              if: (role) => role == 1 || role == 2,
            },
            {
              icon: 'mdi-file-document-box-multiple',
              title: 'Технические осмотры',
              to: 'to',
              if: (role) => role == 1 || role == 2,
            },
            {
              icon: 'mdi-file-document-box-multiple',
              title: 'Расторженные договора',
              to: 'contract_cancel',
              if: (role) => role == 1 || role == 2,
            },
          ],
        },
        {
          icon: 'mdi-exit-to-app',
          title: 'Выход',
          to: '/logout',
          if: (role) => true,
        },
        /* {
          group: '/pages',
          icon: 'mdi-image',
          title: 'pages',
          children: [
            {
              title: 'pricing',
              to: 'pricing'
            },
            {
              title: 'rtl',
              to: 'rtl'
            },
            {
              title: 'timeline',
              to: 'timeline'
            },
            {
              title: 'login',
              to: 'login'
            },
            {
              title: 'register',
              to: 'pricing'
            },
            {
              title: 'lock',
              to: 'lock'
            },
            {
              title: 'user',
              to: 'user'
            },
            {
              title: 'error',
              to: '404'
            }
          ]
        },
        {
          group: '/components',
          icon: 'mdi-view-comfy',
          title: 'components',
          children: [
            {
              title: 'multi',
              group: '',
              children: [
                {
                  title: 'example',
                  href: '#'
                }
              ]
            },
            {
              title: 'buttons',
              to: 'buttons'
            },
            {
              title: 'grid',
              to: 'grid-system'
            },
            {
              title: 'tabs',
              to: 'tabs'
            },
            {
              title: 'notifications',
              to: 'notifications'
            },
            {
              title: 'icons',
              to: 'icons'
            },
            {
              title: 'typography',
              to: 'typography'
            }
          ]
        },
        {
          group: '/forms',
          icon: 'mdi-clipboard-outline',
          title: 'forms',
          children: [
            {
              title: 'rforms',
              to: 'regular'
            },
            {
              title: 'eforms',
              to: 'extended'
            },
            {
              title: 'vforms',
              to: 'validation'
            },
            {
              title: 'wizard',
              to: 'wizard'
            }
          ]
        },
        {
          group: '/tables',
          icon: 'mdi-grid',
          title: 'tables',
          children: [
            {
              title: 'rtables',
              to: 'regular-tables'
            },
            {
              title: 'etables',
              to: 'extended-tables'
            },
            {
              title: 'dtables',
              to: 'data-tables'
            }
          ]
        },
        {
          group: '/maps',
          icon: 'mdi-map-marker',
          title: 'maps',
          children: [
            {
              title: 'google',
              to: 'google-maps'
            },
            {
              title: 'fullscreen',
              to: 'full-screen-map'
            }
          ]
        },
        {
          icon: 'mdi-widgets',
          title: 'widgets',
          to: '/widgets'
        },
        {
          icon: 'mdi-chart-timeline-variant',
          title: 'charts',
          to: '/charts'
        },
        {
          icon: 'mdi-calendar-range',
          title: 'calendar',
          to: '/calendar'
        } */
      ],
    }),

    computed: {
      ...mapState(['barColor', 'barImage']),
      drawer: {
        get () {
          return this.$store.state.drawer
        },
        set (val) {
          this.$store.commit('SET_DRAWER', val)
        },
      },
      computedItems () {
        return this.items.map(this.mapItem)
      },
      profile () {
        return {
          avatar: true,
          group: '',
          title: this.$store.state.user.name,
          children: [
            {
              to: 'profile',
              title: 'Профиль',
            },
          ],
        }
      },
    },

    watch: {
      '$vuetify.breakpoint.smAndDown' (val) {
        this.$emit('update:expandOnHover', !val)
      },
    },

    methods: {
      mapItem (item) {
        return {
          ...item,
          title: this.$t(item.title),
        }
      },
    },
  }
</script>

<style lang="sass">
  @import '~vuetify/src/styles/tools/_rtl.sass'

  #core-navigation-drawer
    &.v-navigation-drawer--mini-variant
      .v-list-item
        justify-content: flex-start !important

      .v-list-group--sub-group
        display: block !important

    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 0px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px
</style>
